/**
 * Slug variabile datatable → chiave icona per `getDatatableColumnIconNode` (`@/comps/datatable-column-icon-nodes`).
 * Unico punto da modificare per cambiare le icone delle colonne in report datatable, Explore “Edit table”, ecc.
 */
export const DATATABLE_VARIABLE_SLUG_TO_ICON_KEY: Record<string, string> = {
  users: 'user2',
  end_user: 'user2',
  retention: 'locatefixed',
  return_rate: 'locatefixed',
  interactions: 'activity',
  n_sessions: 'messagessquare',
  conversations: 'messagessquare',
  conversation_length: 'activity',
  prompts_to_value: 'activity',
  negative: 'arrowdowncircle',
  error_rate: 'arrowdowncircle',
  conversation_error_rate: 'arrowdowncircle',
  bounce_rate: 'circlearrowright',
  error_rate_explicit: 'arrowdowncircle',
  conversation_error_rate_explicit: 'arrowdowncircle',
  sentiment_score: 'sentimenticonz',
  conversation_sentiment_score: 'sentimenticonz',
  sentiment: 'sentiment',
  satisfaction: 'sentimenticonz',
  frustration: 'thumbsdown',
  positive_messages: 'messagecircleheart',
  negative_messages: 'messagecirclewarning',
  session_length: 'activity',
  session_time: 'clock',
  conversation_time: 'clock',
  start_session: 'clock',
  end_session: 'clock',
  thumbs_up: 'thumbsup',
  thumbs_down: 'thumbsdown',
  explicit_feedback_ratio: 'divide',
  paste_output: 'paste_output',
  timestamp: 'clock',
  input_text: 'messagesquare',
  output_text: 'messagesquarereply',
  end_user_z: 'user2',
  cost: 'cost',
  latency: 'latency',
  text_language: 'text_language',
  verbosity: 'messagesquare',
  input_length: 'messagesquare',
  output_length: 'messagesquare',
  pii_removed: 'pii_removed',
  feedback_action_text: 'feedback_action_text',
  feedback_action_rating: 'feedback_action_rating',
  user_rating: 'feedback_action_rating',
  feedback_actions: 'feedback_actions',
  emotions: 'emotions',
  conversation_id: 'conversation',
  interaction_id: 'id',
  topic: 'topic',
  subtopic: 'topic',
  model_suggestion: 'trianglealert',
  user_action: 'user2',
  user_actions: 'user2',
  intents: 'topic',
  topics_conversations: 'topic',
  segments: 'topic',
  n_segments: 'topic',
  n_interactions: 'turns',
  duration: 'clock',
  dropoff_sentiment: 'sentimenticonz',
  conversation_error_status: 'heartpulse',
  rag_details: 'paste_output',
  input_tokens: 'tokens',
  output_tokens: 'tokens',
  labels: 'tag',
  penetration: 'penetration',
  warnings: 'trianglealert',
  roi_hours_saved: 'latency',
  roi_hours_saved_per_user: 'latency',
  roi_hours_saved_per_interaction: 'latency',
  roi_successful_interactions: 'activity',
  roi_success_rate: 'arrowdowncircle',
  roi_value_saved: 'cost',
  roi_value_saved_per_interaction: 'cost',
  total_users: 'user2',
};

export function getDatatableVariableIconKey(slug: string): string {
  return DATATABLE_VARIABLE_SLUG_TO_ICON_KEY[slug] ?? 'tag';
}
